import React from 'react'

import styles from './index.module.css'

// 15分間隔の罫線: 30分単位で太線（実線）、15分単位で点線
const lines = Array.from({ length: 24 * 4 + 1 }, (_, i) => {
  const minutes = i * 15
  return { minutes, dashed: minutes % 30 !== 0 }
})

type Props = {
  pxPerMinute: number
}

export const TimelineGrid: React.FC<Props> = React.memo(({ pxPerMinute }) => (
  <>
    {lines.map(({ minutes, dashed }) => (
      <div
        key={minutes}
        className={`${styles.line} ${dashed ? styles.lineDashed : ''}`}
        style={{ top: minutes * pxPerMinute }}
      />
    ))}
  </>
))
